<mat-form-field class="label" [ngClass]="font?.size">
  <mat-label >{{ textContent?.periodCodeLabel | translate }}</mat-label>
  <mat-select  [formControl]="periodCode" [ngClass]="font?.size">
    <mat-option (click)="onSelectPeriodCode()" [ngClass]="font?.size" *ngFor="let periodCodeOption of periodCodeOptions" [value]="periodCodeOption.id">
      {{ periodCodeOption.name | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>